export default __webpack_public_path__ + "static/media/filter.3136d12d.png";